import axios from 'axios';
import {VUE_APP_APIPATH} from '@/util/globals';

// FAQ
export async function getQuestionAndAnswers(params) {
  return await axios.get(`${VUE_APP_APIPATH}data/question_and_answers?limit=1000`, {
    params: params,
  });
}

// 分店列表
export async function getStores(params) {
  return await axios.get(`${VUE_APP_APIPATH}data/stores?limit=1000`, {
    params: params,
  });
}

// 設定
export async function getSettingData(params) {
  return await axios.get(`${VUE_APP_APIPATH}data/settings`, {
    params: params,
  });
}


// 加盟
export async function getStoreFranchises(joinData) {
  return await axios.post(`${VUE_APP_APIPATH}data/store_franchises`, joinData);
}

// 建立訂單
export async function createOrder(orderData) {
  return await axios.post(`${VUE_APP_APIPATH}order/create_order`, orderData);
}


// 獲得訂單詳細
export async function getOrderDetail(trade_no) {
  return await axios.get(`${VUE_APP_APIPATH}order/order_detail`, {
    params: {trade_no: trade_no},
  });
}


// 完成訂單
export async function getCompleteOrder(trade_no, payInfo) {
  return await axios.post(`${VUE_APP_APIPATH}order/complete_order?trade_no=${trade_no}`, {
    pay_info: payInfo,
  });
}


